/* eslint-disable @typescript-eslint/no-explicit-any */
import VueRouter, { RawLocation } from 'vue-router';

export class Settings {
	router: VueRouter;
	public constructor(settings: any, router: VueRouter) {
		Object.assign(this, settings);
		this.router = router;
	}
	public absoluteUrl(url: string) {
		return window.location.origin + this.url(url);
	}
	public urlFromRoute(url: RawLocation) {
		return this.url(this.router.resolve(url).href);
	}
	public absoluteUrlFromRoute(url: RawLocation) {
		return this.absoluteUrl(this.router.resolve(url).href);
	}
}
export interface Settings {
	base: string;
	url(url: string): string;
	name: string;
	author: string;
	description: string;
	minDate: string;
	authAudience: string;
	authDomain: string;
	authClientId: string;
	mainMenu: Array<{ icon: [string, string] | string; title: string; to: string; exact: boolean }>;
	landingMenu: Array<{ icon: [string, string] | string; title: string; to: string; exact: boolean; isDisabled: boolean }>;
	sideBar: Array<{ icon: [string, string] | string; title: string; to: string; exact: boolean }>;
	errorPages: {
		default: { icon: [string, string]; title: string; message: string; statusCode: number };
		[code: string]: { icon: [string, string]; title: string; message: string; statusCode: number };
	};
	cardTypeQuestionId: string;
	cardTypeAnswerId: string;
	summaryForm: string;
	programId: string;
	penSwirl: string;
	surveyId: string;
	sourceId: string;
	documentTypeId: string;
	landingPageModalExpDate: string;
	reenrollStartDate: string;
	reenrollEndDate: string;
	lockEnabled: string;
	lockPassword: string;
	isOver18: string;
	isOver18Yes: string;
	isOver18No: string;
	isUsCitizen: string;
	isUsCitizenYes: string;
	isUsCitizenNo: string;
	doesHaveIndication: string;
	doesHaveIndicationYes: string;
	doesHaveIndicationNo: string;
	isInsured: string;
	isInsuredYes: string;
	isInsuredNo: string;
	isGovernmentInsured: string;
	isGovernmentInsuredYes: string;
	isGovernmentInsuredNo: string;
	isAuthorized: string;
	isAuthorizedYes: string;
	isAuthorizedNo: string;
	brandId: string;
	senderId: string;
	questionId1User: string;
	answerId1UserHub: string;
	answerId1UserHCP: string;
}
